/** Mutable dictionaries used by t()/get() and lookups. Filled from local files, then overlaid by Contentful. */
export const dictionaries = {};

/** Snapshot of local src/content so remote fetch can re-merge without stacking. */
export const localDictionaries = {};
